module.exports = __webpack_public_path__ + "static/media/rotate-phone-icon.4d660dba.svg";